import React, { useEffect } from "react";
import Navbar from "../Navbar";
import {
  Box,
  Button,
  TextField,
  Grid,
  Divider,
  Typography,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function EditCustomer(props) {
  const navigate = useNavigate();

  //useState Declaration
  const [loading, setLoading] = useState(true);
  const [customerInput, setcustomer] = useState({
    name: "",
    gstno: "",
    pcode: "",
    acode: "",
    maddress: "",
    email: "",
    address: "",
    cname: "",
    cnamecontact: "",
    error_list: [],
  });
  //error handling
  const [error, setError] = useState({
    name: "",
    gstno: "",
    pcode: "",
    acode: "",
    maddress: "",
    email: "",
    address: "",
    cname: "",
    cnamecontact: "",
    error_list: [],
  });

  //colour palette
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });


  //view api for displaying the id data
  const { id } = useParams();
  useEffect(() => {
    const customer_id = id;
    axios.get(`/api/edit-customer/${customer_id}`).then((res) => {
      if (res.data.status === 200) {
        setcustomer(res.data.customer);
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/customermaster");
      }
      setLoading(false);
    });
  }, [id, navigate]);

  //input handling function
  const handleInput = (e) => {
    e.persist();
    setcustomer({ ...customerInput, [e.target.name]: e.target.value });
  };
  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    );
  }

  //api for updating the new data
  const updateCategory = (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const customer_id = id;
    const data = {
      name: customerInput.name,
      gstno: customerInput.gstno,
      // col1:customerInput.col1,
      pcode: customerInput.pcode,
      acode: customerInput.acode,
      maddress: customerInput.maddress,
      email: customerInput.email,
      address: customerInput.address,
      cname: customerInput.cname,
      cnamecontact: customerInput.cnamecontact,
      user_id:userId,
    }
    axios.put(`/api/update-customer/${customer_id}`, data).then((res) => {
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        setError([]);
        navigate("/certificates/customermaster");
      } else if (res.data.status === 422) {
        // swal("All fields are mandatory","","error");
        setError({ ...customerInput, error_list: res.data.errors });
        // setError(res.data.errors);
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/customermaster");
      }
    });
  };


  //main function
  return (
    <div>
      <Navbar />
      <div className="card px-8 m-5">
        <div className="card-header">
          <Grid container spacing={70}>
            <Grid item xs={8}>
              <h4>Edit Customer</h4>
            </Grid>
            <Grid item xs={4}>
              <ThemeProvider theme={theme}>
                <Button
                  component={Link}
                  to="/certificates/customermaster"
                  variant="contained"
                  color="apple"
                >
                  Back
                </Button>
              </ThemeProvider>
            </Grid>
          </Grid>
        </div>
        <form onSubmit={updateCategory} id="CATEGORY_FORM">
          <Box paddingTop={1} borderRadius={1} paddingLeft={5} paddingRight={5}>
            <Grid container spacing={5}>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="name"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={customerInput.name}
                  id="filled-basic"
                  margin="normal"
                  label="Name"
                  variant="filled"
                />
                <span style={{ color: "red" }}>{error.error_list.name}</span>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="gstno"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={customerInput.gstno}
                  id="filled-basic"
                  margin="normal"
                  label="GST NO"
                  variant="filled"
                />
                {/* <span style={{color: "red"}} >{error.error_list.gstno}</span> */}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="pcode"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={customerInput.pcode}
                  id="filled-basic"
                  margin="normal"
                  label="Party Code"
                  variant="filled"
                />
                <span style={{ color: "red" }}>{error.error_list.pcode}</span>
              </Grid>
            </Grid>

            <Grid container spacing={5}>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="acode"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={customerInput.acode}
                  id="filled-basic"
                  margin="normal"
                  label="Associate Code"
                  variant="filled"
                />
                <span style={{ color: "red" }}>{error.error_list.acode}</span>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="maddress"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={customerInput.maddress}
                  id="filled-basic"
                  margin="normal"
                  label="Mini Address"
                  variant="filled"
                />
                <span style={{ color: "red" }}>
                  {error.error_list.maddress}
                </span>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="email"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={customerInput.email}
                  id="filled-basic"
                  margin="normal"
                  label="Email"
                  variant="filled"
                />
                <span style={{ color: "red" }}>{error.error_list.email}</span>
              </Grid>
            </Grid>
            {/* <Grid container spacing={5}>
           
            <Grid item xs={6}> */}
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              name="address"
              sx={{ input: { background: "white" } }}
              onChange={handleInput}
              value={customerInput.address}
              id="filled-basic"
              margin="normal"
              label="Address"
              variant="filled"
            />
            <span style={{ color: "red" }}>{error.error_list.address}</span>
            <Grid container spacing={5}>
              <Grid item xs={6}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="cname"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={customerInput.cname}
                  id="filled-basic"
                  margin="normal"
                  label="Party Contact Person"
                  variant="filled"
                />
                <span style={{ color: "red" }}>{error.error_list.cname}</span>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="cnamecontact"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={customerInput.cnamecontact}
                  id="filled-basic"
                  margin="normal"
                  label="Contact Number"
                  variant="filled"
                />
                <span style={{ color: "red" }}>
                  {error.error_list.cnamecontact}
                </span>
              </Grid>
            </Grid>
            <Box
              marginTop={1}
              display="flex"
              padding={3}
              borderRadius={5}
              alignItems="center"
              justifyContent={"center"}
            >
              <ThemeProvider theme={theme}>
                <Button
                  style={{
                    maxWidth: "200px",
                    maxHeight: "100px",
                    minWidth: "50px",
                    minHeight: "30px",
                  }}
                  color="apple"
                  type="submit"
                  variant="contained"
                >
                  Update
                </Button>
              </ThemeProvider>
            </Box>
          </Box>
        </form>
      </div>
    </div>
  );
}

export default EditCustomer;
